import { render, staticRenderFns } from "./cadtecnicos.vue?vue&type=template&id=01256d24&"
import script from "./cadtecnicos.vue?vue&type=script&lang=js&"
export * from "./cadtecnicos.vue?vue&type=script&lang=js&"
import style0 from "./cadtecnicos.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports